import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/data'
const plural = 'csvs'
const single = 'csv'

const cdi = new ApiCore({
	create: true,
	url: url,
	plural: plural,
	single: single,
})

axios.defaults.timeout = 30000;

cdi.push = (id, payload, options) => {
	return axios
		.post(`${apiProvider.BASE_URL}/v1/data/push/${id}`, payload, options)
		.then(handleResponse)
		.catch(handleError);
}

cdi.pull = (id, payload, options) => {
	return axios
		.post(`${apiProvider.BASE_URL}/v1/data/pull/${id}`, payload, options)
		.then(handleResponse)
		.catch(handleError);
}

export default cdi
